module.exports = __webpack_public_path__ + "6e90b1670ee01c9669432d158b817285.png";